export const UNO_URL = "https://api.simulanis.io";
export const applicationId = "16269833-3c0f-42a4-8e89-dc3347fb908c";
export const redirectUrl = "https://apps.simulanis.io";
export const defaultLogo = "https://cdn.simulanis.io/sso/logos/default_simulanis.png"
export const API_URL=   "https://api.creator.simulanis.io"
// export const API_URL=   "http://localhost:3333"
export const previewApi =  "https://api.creator.simulanis.io"
// export const previewApi =  "http://localhost:3333"
export const minimumTimeSpent = 5
export const recentProject = 3